export const BasicType = {
  PAGE: "page" as const,
  SECTION: "section" as const,
  COLUMN: "column" as const,
  GROUP: "group" as const,
  TEXT: "text" as const,
  IMAGE: "image" as const,
  DIVIDER: "divider" as const,
  SPACER: "spacer" as const,
  BUTTON: "button" as const,
  WRAPPER: "wrapper" as const,
  RAW: "raw" as const,
  HERO: "hero" as const,
  CAROUSEL: "carousel" as const,
  NAVBAR: "navbar" as const,
  NAVBAR_LINK: "navbar-link" as const,
  SOCIAL: "social" as const,
  SOCIAL_ELEMENT: "social-element" as const,

  MERGETAG: "mergetag" as const,
  LINE_BREAK: "line-break" as const,
  PLACEHOLDER: "placeholder" as const,

  TABLE: "table" as const,

  // extra
  DANGEROUS_CODE: "dangerous-code" as const,
  HTML_NODE: "html-node" as const,
  HTML_BLOCK_NODE: "html-block-node" as const,
  HTML_DOM_NODE: "html-dom-node" as const,

  CONTENT_WIDGET: "content_widget" as const,
  SECTION_WIDGET: "section_widget" as const,
  WRAPPER_WIDGET: "wrapper_widget" as const,

  PAGE_HEADER: "page-header" as const,
  PAGE_FOOTER: "page-footer" as const,
};

export const StandardType = {
  STANDARD_HERO: "standard-hero" as const,
  STANDARD_WRAPPER: "standard-wrapper" as const,
  STANDARD_SECTION: "standard-section" as const,
  STANDARD_GROUP: "standard-group" as const,
  STANDARD_COLUMN: "standard-column" as const,
  STANDARD_IMAGE: "standard-image" as const,
  STANDARD_DIVIDER: "standard-divider" as const,
  STANDARD_SPACER: "standard-spacer" as const,
  STANDARD_NAVBAR: "standard-navbar" as const,
  STANDARD_NAVBAR_LINK: "standard-navbar-link" as const,
  STANDARD_SOCIAL: "standard-social" as const,
  STANDARD_SOCIAL_ELEMENT: "standard-social-element" as const,
  STANDARD_BUTTON: "standard-button" as const,
  STANDARD_TEXT: "standard-text" as const,
  STANDARD_PARAGRAPH: "standard-paragraph" as const,
  STANDARD_H1: "standard-h1" as const,
  STANDARD_H2: "standard-h2" as const,
  STANDARD_H3: "standard-h3" as const,
  STANDARD_H4: "standard-h4" as const,
  STANDARD_TABLE: "standard-table" as const,
  STANDARD_TEXT_LIST: "standard-text-list" as const,
  STANDARD_TEXT_LIST_ITEM: "standard-text-list-item" as const,
  STANDARD_BLOCK_QUOTE: "standard-blockquote" as const,

  //
  STANDARD_TABLE2: "standard-table2" as const,
  STANDARD_TABLE2_TR: "standard-table2-tr" as const,
  STANDARD_TABLE2_TD: "standard-table2-td" as const,
};

export const LogicType = {
  FOR_EACH: "logic-for-each" as const,
  SHOW: "logic-show" as const,
};

export const ElementType = {
  ...BasicType,
  ...StandardType,
  ...LogicType,
};
